module.exports = {
  name: 'Magyar',
  key: 'hu',
  'Open in Debug Map': 'Megnyitás a hibakereső térképen',
  'Open in Mapillary': 'Megnyitás a Mapillaryban',
  'GPX': 'GPX fájl exportálása',
  'Open in editor': 'Megnyitás a szerkesztőben',
  'Open in JOSM': 'Megnyitás a JOSM-ben',
  'Select language': 'Nyelv kiválasztása',
  'Share Route': 'Útvonal megosztása',
  'Link': 'Hivatkozás',
  'Shortlink': 'Rövid hivatkozás',
  'Start - press enter to drop marker': 'Start - nyomjon entert a kezdőpont kijelöléséhez',
  'End - press enter to drop marker': 'Cél - nyomjon entert a cél kijelöléséhez',
  'Via point - press enter to drop marker': 'Köztes megálló - nyomjon entert a köztes pont kijelöléséhez',
  'Build': 'Build: '
};
